<template>
  <div>

    <kanban-board
      :key="kanbanRenderKey"
      :stages="stagesArray"
      :blocks="dataFormatted"
      class="kanban mb-2"
      @update-block="updateTaskStage"
    >
      <div
        v-for="stage in fields[options.stage_field]['options']"
        :slot="stage"
        :key="stage"
        :class="{
          'can-change-status': canChangeStatus,
        }"
      >
        <div class="card shadow-0">
          <div class="card-body p-2">
            <div class="font-weight-bold m-0 d-flex">
              <div class="">{{ $t(`modules.${$route.params.module}.entities.${render.data}.fields.${options.stage_field}.options.${stage}`) }}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        class=""
        v-for="block in dataFormatted"
        :key="block.id"
        :slot="block.id"
      >
        <a
          :class="{
            'card mb-2 p-2 text-secondary': true,
            'cursor-pointer': canChangeStatus,
          }"
          :href="'#' + block.id"
        >
          <div>
            <span class="w-auto mb-1 badge badge-info text-left" v-if="options.category_field && block.type">
              {{ $t(`modules.${$route.params.module}.entities.${render.data}.fields.${options.category_field}.options.${block.type}`) }}
            </span>
          </div>
          <div class="title-field font-weight-semibold">{{ block[config.name_field] }}</div>
          <div v-if="options.render_fields && options.render_fields.length > 0" class="small text-lightslate">
            <div v-for="field in options.render_fields" v-if="block[field]" class="render-field">
              {{ block[field] }}
              <span v-if="fields[field] && fields[field].display_after">{{ fields[field].display_after }}</span>
            </div>
          </div>
          <div class="mt-1 small" v-if="options.actions_field && block[options.actions_field] && block[options.actions_field].length > 0">
            <div
              v-for="action in block[options.actions_field]"
            >
            —
              <span
                :class="{
                  'text-striked': action.done,
                }"
              >
                {{ action.name }}
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-end align-items-center" v-if="
            (options.date_field && block[options.date_field]) || (options.user_field && block[options.user_field])
          ">
            <div class="small text-grey">
              <span v-if="options.date_field && block[options.date_field]">
                {{ $d(new Date(block[options.date_field]), 'shortText') }}
              </span>
            </div>
            <div>
              <div v-if="options.user_field && block[options.user_field] && users[block[options.user_field]]">
                <el-avatar
                  size="xsmall"
                  :src="users[block[options.user_field]].avatar.thumb"
                  class="ml-1"
                  v-tooltip="{
                    content: users[block[options.user_field]].full_name,
                    placement: 'top',
                  }"
                />
              </div>
            </div>
          </div>
        </a>
      </div>
    </kanban-board>

  </div>
</template>

<script>

import Index from './_Index'
import _ from 'lodash'

import {
  MODULE_UPDATE,
} from '../../../store/mutations-types'

export default {
  extends: Index,
  name: 'ModuleIndexKanban',
  data() {
    return {
      kanbanRenderKey: 'init',
    }
  },
  computed: {
    stagesArray () {
      return Object.keys(this.fields[this.options.stage_field]['options']);
    },
    isCurrentUserWorldInternal () {
      return this.$store.getters['auth/isWorldInternal']
    },
    dataFormatted () {
      return _.cloneDeep(this.dataFiltered).map(elem => {
        elem.status = elem[this.options.stage_field]
        return elem
      })
    },
    users () {
      let users = this.$store.getters['world/getUsers'] ? this.$store.getters['world/getUsers'] : [];
      return _.keyBy(users, 'id')
    },
    canChangeStatus () {
      if (this.isCurrentUserWorldInternal) {
        return true
      }

      return typeof this.fields[this.options.stage_field].internal_edit_only === 'undefined' ||
             (
                 this.fields[this.options.stage_field].internal_edit_only === true &&
                 this.isCurrentUserWorldInternal
             )

    },
  },
  methods: {
    updateTaskStage (id, status) {

      if (!this.canChangeStatus) {
        this.kanbanRenderKey = Date.now()
        return
      }

      let blockId = this.data.findIndex(b => b.id === Number(id))
      let oldStatus = this.data[blockId][this.options.stage_field]
      this.$set(this.data[blockId], this.options.stage_field, status)

      this.$store.dispatch('module/' + MODULE_UPDATE, {
        worldId: this.$route.params.world,
        moduleId: this.$route.params.module,
        entityType: this.module.pages[this.$route.params.page].render.data,
        data: this.data[blockId],
      }).then(data => {
      }).catch(error => {
        this.notifError(error)
        this.$set(this.data[blockId], this.options.stage_field, oldStatus)
        // force to re-render the kanban
        this.kanbanRenderKey = Date.now()
      })

    },
  }
}
</script>
<style lang="scss" scoped>

::v-deep {
  .kanban {
    overflow-x: scroll;
  }
  .drag-list {
    min-width: 600px;
  }
  .can-change-status {
    .drag-item {
      cursor: move;
    }
  }
  .drag-item {
    transition: all .3s cubic-bezier(.23,1,.32,1);
    word-break: break-word;
  }
  .drag-item.is-moving {
    transition: all .3s cubic-bezier(.23,1,.32,1);
    transform: scale(1.02);
    opacity: .8;
  }
  .drag-options {
    position: absolute;
    top: 44px;
    left: 0;
    // width: 100%;
    height: 100%;
    padding: 10px;
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    opacity: 0;
    transition: all .3s cubic-bezier(.23,1,.32,1)
  }
  .drag-options.active {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  .drag-options-label {
    display: block;
    margin: 0 0 5px;
  }
  .drag-options-label input {
    opacity: .6;
  }
  .drag-options-label span {
    display: inline-block;
    font-size: .9rem;
    font-weight: 400;
    margin-left: 5px;
  }
}

.kanban {
  ::v-deep .badge {
    white-space: normal !important;
  }
  ul, ::v-deep ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  ::v-deep > .drag-list {
    display: flex;
    margin: 0 -5px;
    > .drag-column {
      padding: 0px 5px;
      -ms-flex-preferred-size: 0;
      flex-basis: 0;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      max-width: 100%;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      .drag-inner-list {
        min-height: 50%;
      }
    }
  }
}
.text-striked {
  text-decoration: line-through rgba(black, .5);
  opacity: 0.5;
}
.title-field {
  line-height: 1.2em;
  padding: 3px 0;
}
.render-field {
  padding: 3px 0;
  line-height: 1em;
}
</style>

